module.exports = __webpack_public_path__ + "img/shn.6560d76b.svg";